import { render, staticRenderFns } from "./kkType.vue?vue&type=template&id=3a3599e2&scoped=true&"
import script from "./kkType.vue?vue&type=script&lang=js&"
export * from "./kkType.vue?vue&type=script&lang=js&"
import style0 from "./kkType.vue?vue&type=style&index=0&id=3a3599e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3599e2",
  null
  
)

component.options.__file = "kkType.vue"
export default component.exports